import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme/theme';
import { AppRoutes } from './routes/routes';
import { useSelector } from 'react-redux';
import { RootState } from './api/store';
import { ToastContainer } from './components/shared/toast/ToastContainer';
import { GlobalConfirmationDialog } from './components/shared/confirmationDialog/globalConfirmationDialog';
import { LoaderOverlay } from './components/shared/loader/LoaderOverlay';
import { DeviceErrorPage } from './components/shared/errorPage/DeviceErrorPage';
import { canAccessApp } from './utils/deviceCheck';
import { StorageKeys } from './utils/localStorageKeys';

const AppContent: React.FC = () => {
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check access on mount
    setIsLoading(false);
  }, []);

  const handleEnableDevMode = () => {
    localStorage.setItem(StorageKeys.devMode, 'true');
    window.location.reload();
  };

  if (isLoading) {
    return null;
  }

  // Check if user can access the app
  if (!canAccessApp(user, isAuthenticated)) {
    return <DeviceErrorPage onEnableDevMode={handleEnableDevMode} />;
  }

  return (
    <BrowserRouter>
      <AppRoutes />
      <ToastContainer />
      <GlobalConfirmationDialog />
      <LoaderOverlay />
    </BrowserRouter>
  );
};

export const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppContent />
    </ThemeProvider>
  );
};
